/**
 * The app is light-only now. The old selector applied a "Midnight Luxe"
 * variant as inline CSS variables on the root element, which is also why
 * light mode never stuck: the variables overrode the light class on every
 * mount. App.tsx clears those leftovers once at boot; this component stays
 * as a no-op so old import sites keep compiling.
 */
export function ThemeSelector(_props: { variant?: 'outline' | 'ghost' }) {
  return null
}
